var map = {
	"./cat-choice.png": 5435,
	"./cat.png": 8489,
	"./dog-choice.png": 3729,
	"./dog.png": 8480,
	"./kitten.png": 6078,
	"./premium-badge.png": 7643,
	"./premium-quality.png": 778,
	"./puppy.png": 3453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9163;